import React from 'react';

const History = () => {
    return(
        <div>
            <h1>About this Algorithm:</h1>
            <p>The Game of Life is a cellular automaton created by the British mathematician John Horton Conway in 1970.
                Conway was motivated by his interest in mathematical logic and simulation games made by Stanislaw Ulam. Ulam
                himself was inspired by John von Neumann and made his simulations according to Neumann's work.
                In the 1940s, Neumann defined life as a creation which can reproduce itself and simulate a Turing machine.
                Turing completeness states that a system is turing complete if it can simulate a turing machine. A Turing machine 
                can compute anything a computer can.
            </p>
        </div>
    );
}

export default History;